import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const EmployeePolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  hrContact,
  payrollContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Employee_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Employee Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Employee Expectations</h4>
      <ul>
        <li>Adhere to all company policies, procedures, and health & safety regulations.</li>
        <li>Maintain professionalism, honesty, and respect towards colleagues, clients, and management.</li>
        <li>Attend work punctually, complete assigned duties diligently, and communicate absences promptly.</li>
        <li>Comply with company dress code and wear the approved company uniform where applicable, maintaining a professional appearance at all times.</li>
        <li>Report any misconduct, hazards, or concerns through appropriate channels.</li>
        <li>Comply with relevant legal requirements, including licensing, qualifications, and training.</li>
      </ul>

      <h4 className="section-title">2. Employee Benefits and Entitlements</h4>
      <ul>
        <li>Receive a fair wage in accordance with employment contracts and applicable minimum wage laws.</li>
        <li>Eligibility for overtime pay, allowances (e.g., travel, subsistence) as outlined in contracts or company policy.</li>
        <li>Entitlement to statutory holiday leave, sick pay, maternity/paternity leave, and other legal employment rights.</li>
        <li>Access to company benefits, including pension schemes, Employee Assistance Programmes, and training opportunities.</li>
      </ul>

      <h4 className="section-title">3. Working Hours and Attendance</h4>
      <p className="section-content">
        Employees are expected to work the hours agreed in their contracts and adhere to company attendance policies. Any requests for flexible working or time off should follow company procedures.
      </p>

      <h4 className="section-title">4. Legal Employment Rights</h4>
      <p className="section-content">
        The company complies fully with all employment legislation including but not limited to the Employment Rights Act, Working Time Regulations, Equality Act, and National Minimum Wage legislation.
      </p>

      <h4 className="section-title">5. Disciplinary and Grievance Procedures</h4>
      <p className="section-content">
        The company has clear disciplinary and grievance procedures to address any workplace issues fairly and promptly.
      </p>

      <h4 className="section-title">6. Contact Information</h4>
      <p><strong>Human Resources:</strong> {hrContact || "[Insert Contact]"}</p>
      <p><strong>Payroll Department:</strong> {payrollContact || "[Insert Contact]"}</p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and agree to comply with the Employee Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default EmployeePolicy;

